import { Component, OnInit } from '@angular/core';
import { CentersService } from 'src/app/_services/centers.service';
import { environment, baseUrl } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Center } from 'src/app/_models/center.model';
import { showNotification } from 'src/app/helpers/show-toast';
import { DeleteModalComponent } from '@components/delete-modal/delete-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { sortTable } from 'src/app/helpers/sort-table';

@Component({
  selector: 'app-centers-list',
  templateUrl: './centers-list.component.html',
  styleUrls: ['./centers-list.component.scss'],
})
export class CentersListComponent implements OnInit {
  pageTitle: string = 'Labs';
  placeholder: string = 'Search by lab name …';
  labs: Center[] = [];
  filteredLabs: Center[] = [];
  invertSort: boolean = false;
  theadArray = [
    'Lab EN Name',
    'Lab AR Name',
    'Lab Type',
    'Lab Phone',
    'Lab Email',
    'Lab Country',
    'Lab Active',
    'Lab Actions',
  ];
  pageId: number = 1;
  searchString: string = '';
  isDataFilteredAfterSearch: boolean = false;

  modalRef: BsModalRef;

  constructor(
    private centerService: CentersService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.handleGetCentersByTypeId(this.pageId);
  }

  getAllLabs() {
    this.centerService.getAllCenters().subscribe((res) => {
      res?.data?.centers.map((lab: Center) => {
        lab.logo = `${lab.logo}`;
        this.labs.push(lab);
      });

      this.filteredLabs = [...this.labs];
    });
  }

  onSearchLab(searchString) {
    if (searchString) {
      this.searchString = searchString;
      this.isDataFilteredAfterSearch = true;
      this.centerService.searchCenterByName(searchString, this.pageId - 1).subscribe((response) => {
        this.filteredLabs = response['data']['centers'];
      });
    } else {
      this.searchString = '';
      this.filteredLabs = [...this.labs];
      this.isDataFilteredAfterSearch = false;
    }
  }

  onSearchInputKeyup(searchString) {
    if (!searchString && this.isDataFilteredAfterSearch) {
      this.filteredLabs = [...this.labs];
    }
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredLabs = sortTable(
      this.filteredLabs,
      'name',
      this.invertSort
    );
  }

  onLabActiveChange(event, lab) {
    lab.isActive = event.target.checked;

    this.centerService.updateCenter(null, lab).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} lab is ${response.data.isActive ? 'active' : 'not active'
        }`,
        this.toastr
      );
    });
  }

  onDeleteLab(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.name,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteLabSubmit(item.name, data);
    });
  }

  onDeleteLabSubmit(labName, labId) {
    this.centerService.deleteCenter(labId).subscribe((res) => {
      showNotification('success', `${labName} has been deleted`, this.toastr);

      this.labs = this.labs.filter((lab) => lab.id !== labId);

      this.filteredLabs = [...this.labs];

      this.modalRef.hide();
    });
  }

  changePageId(pageId: number) {
    this.pageId = pageId;
    this.handleGetCentersByTypeId(pageId);
  }

  handleGetCentersByTypeId(typeId: number) {
    this.centerService.getCentersByTypeId(typeId - 1)
      .subscribe(res => {
        this.labs = res.data.centers;
        this.filteredLabs = res.data.centers;
        this.isDataFilteredAfterSearch = false;
        this.searchString = '';
      });
  }
}
